export default __webpack_public_path__ + "static/media/prev-earbuddyzultrapro.35e5677b.jpg";